import { useMemo } from 'react';
import * as THREE from 'three';

/**
 * Placeholder powered armor (faces -Z, up +Y, like the camera). To be replaced by the real
 * glTF armor model with the player's avatar behind the visor.
 */
export function Rival({ color = 0xa9c4db }: { color?: number }) {
  const m = useMemo(
    () => ({
      armor: new THREE.MeshStandardMaterial({ color: 0x50565f, roughness: 0.42, metalness: 0.65 }),
      dark: new THREE.MeshStandardMaterial({ color: 0x22262c, roughness: 0.6, metalness: 0.4 }),
      ice: new THREE.MeshStandardMaterial({ color, emissive: color, emissiveIntensity: 1.6 }),
    }),
    [color],
  );
  const box = (size: [number, number, number], pos: [number, number, number], mat: THREE.Material, key: string) => (
    <mesh key={key} position={pos} material={mat}>
      <boxGeometry args={size} />
    </mesh>
  );
  return (
    <>
      {box([0.62, 0.66, 0.4], [0, 0.08, 0], m.armor, 'torso')}
      {box([0.5, 0.22, 0.36], [0, -0.34, 0], m.dark, 'waist')}
      {box([0.32, 0.24, 0.48], [-0.45, 0.36, 0], m.armor, 'shoulderL')}
      {box([0.32, 0.24, 0.48], [0.45, 0.36, 0], m.armor, 'shoulderR')}
      {box([0.17, 0.55, 0.2], [-0.43, -0.02, 0], m.dark, 'armL')}
      {box([0.17, 0.55, 0.2], [0.43, -0.02, 0], m.dark, 'armR')}
      {box([0.2, 0.62, 0.24], [-0.16, -0.76, 0], m.armor, 'legL')}
      {box([0.2, 0.62, 0.24], [0.16, -0.76, 0], m.armor, 'legR')}
      {box([0.48, 0.56, 0.24], [0, 0.1, 0.32], m.dark, 'pack')}
      {box([0.12, 0.08, 0.12], [-0.13, -0.22, 0.4], m.ice, 'thrusterL')}
      {box([0.12, 0.08, 0.12], [0.13, -0.22, 0.4], m.ice, 'thrusterR')}
      <mesh position={[0, 0.6, 0]} material={m.armor}>
        <sphereGeometry args={[0.22, 20, 14]} />
      </mesh>
      {box([0.3, 0.12, 0.06], [0, 0.62, -0.19], m.ice, 'visor')}
      {box([0.05, 0.42, 0.03], [-0.16, 0.12, -0.21], m.ice, 'stripL')}
      {box([0.05, 0.42, 0.03], [0.16, 0.12, -0.21], m.ice, 'stripR')}
    </>
  );
}
